function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from 'styled-components';
var BirminghamMidshiresIcon = function BirminghamMidshiresIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3807 5.5L18 9L14.3807 12.5L13 11.1648L14.2615 9.94413L14.261 9.875H3.625C3.27715 9.875 3.05387 10.0106 3.00855 10.0998L3 10.1307V20.8693C3 20.9441 3.18462 21.088 3.5005 21.119L3.625 21.125H13.375C13.7229 21.125 13.9461 20.9894 13.9915 20.9002L14 20.8693V19H16V20.8693C16 22.0538 14.8743 22.9277 13.5425 22.9957L13.375 23H3.625C2.27755 23 1.098 22.1735 1.0058 21.0157L1 20.8693V10.1307C1 8.94619 2.12565 8.07229 3.45751 8.00427L3.625 8H14.204L13 6.83521L14.3807 5.5ZM20.375 1C21.7224 1 22.902 1.88163 22.9942 3.11656L23 3.27273V14.7273C23 15.9907 21.8743 16.9229 20.5425 16.9954L20.375 17H9.796L11 18.1648L9.61929 19.5L6 16L9.61929 12.5L11 13.8352L9.795 15H20.375C20.7229 15 20.9461 14.8554 20.9914 14.7603L21 14.7273V3.27273C21 3.19298 20.8154 3.03952 20.4995 3.0064L20.375 3H10.625C10.2771 3 10.0539 3.1446 10.0085 3.23975L10 3.27273V6H8V3.27273C8 2.00927 9.12565 1.07711 10.4575 1.00455L10.625 1H20.375Z",
    fill: "currentColor"
  }));
};
BirminghamMidshiresIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42526 14.21V12.595H2.9292V9.36503H6.42526V7.65503L9.63786 10.885L6.42526 14.21ZM3.9685 3V6.99H0V17.535H12V3H3.9685ZM3.21259 3.57001L0.0944824 6.23001H3.21259V3.57001ZM21.4489 16.3H17.9528V17.915L14.6458 14.685L17.8584 11.455V13.07H21.3544V16.3H21.4489ZM13.3228 7.46503V19.625H12V22H24V7.46503H13.3228Z",
    fill: "currentColor"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3807 5.5L18 9L14.3807 12.5L13 11.1648L14.2615 9.94413L14.261 9.875H3.625C3.27715 9.875 3.05387 10.0106 3.00855 10.0998L3 10.1307V20.8693C3 20.9441 3.18462 21.088 3.5005 21.119L3.625 21.125H13.375C13.7229 21.125 13.9461 20.9894 13.9915 20.9002L14 20.8693V19H16V20.8693C16 22.0538 14.8743 22.9277 13.5425 22.9957L13.375 23H3.625C2.27755 23 1.098 22.1735 1.0058 21.0157L1 20.8693V10.1307C1 8.94619 2.12565 8.07229 3.45751 8.00427L3.625 8H14.204L13 6.83521L14.3807 5.5ZM20.375 1C21.7224 1 22.902 1.88163 22.9942 3.11656L23 3.27273V14.7273C23 15.9907 21.8743 16.9229 20.5425 16.9954L20.375 17H9.796L11 18.1648L9.61929 19.5L6 16L9.61929 12.5L11 13.8352L9.795 15H20.375C20.7229 15 20.9461 14.8554 20.9914 14.7603L21 14.7273V3.27273C21 3.19298 20.8154 3.03952 20.4995 3.0064L20.375 3H10.625C10.2771 3 10.0539 3.1446 10.0085 3.23975L10 3.27273V6H8V3.27273C8 2.00927 9.12565 1.07711 10.4575 1.00455L10.625 1H20.375Z",
    fill: "currentColor"
  }));
};
HalifaxIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsReimaginedIcon = function LloydsReimaginedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.65 21.25H11.35V24H12.65V21.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.65 17H11.35V19.75H12.65V17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.65 12.75H11.35V15.5H12.65V12.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.65 0H11.35V2.75H12.65V0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.65 8.5H11.35V11.25H12.65V8.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.65 4.25H11.35V7H12.65V4.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21L9 18.2V5.8L0 3V21ZM1.3 4.76001L7.7 6.76001V17.24L1.3 19.24V4.76001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.2L24 21V3L15 5.8V18.2ZM22.7 19.24L16.3 17.24V6.76001L22.7 4.76V19.24Z",
    fill: "currentColor"
  }));
};
LloydsReimaginedIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42526 14.21V12.595H2.9292V9.36503H6.42526V7.65503L9.63786 10.885L6.42526 14.21ZM3.9685 3V6.99H0V17.535H12V3H3.9685ZM3.21259 3.57001L0.0944824 6.23001H3.21259V3.57001ZM21.4489 16.3H17.9528V17.915L14.6458 14.685L17.8584 11.455V13.07H21.3544V16.3H21.4489ZM13.3228 7.46503V19.625H12V22H24V7.46503H13.3228Z",
    fill: "currentColor"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { LLOYDS, BIRMINGHAM_MIDSHIRES, BOS, HALIFAX, LLOYDS2023 } from "../../constants";
export default function Compare(_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme();
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.compare) {
    svg = theme.assets.icons.compare;
  } else {
    switch (brand) {
      case BIRMINGHAM_MIDSHIRES:
        svg = BirminghamMidshiresIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsReimaginedIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      default:
        console.warn("Icon \"Compare\" is not available for brand ".concat(brand));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}